import * as React from 'react';
import { Form, Progress, Spin } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

import { transformNum } from '../../utils/common';
import Empty from '../empty';
import styles from './index.module.less';

export interface WorkstationInfoProps {
  loading: boolean;
  curPage: number;
  totalPage: number;
  curWorkstationList: any[];
}
const WorkstationInfo: React.FC<WorkstationInfoProps> = (props) => {
  const renderWorkstationInfo = (workstation: any, index: number) => {
    const totalThroughput = workstation.throughput || 0;
    const target = workstation.target || 0;
    const color = totalThroughput >= target ? '#19BC5C' : '#FF9900';
    return (
      <div
        key={index}
        className={styles.box}
      >
        <div className={styles.boxHead}>
          <div
            className={styles.name}
            title={workstation.workstation}
          >
            {workstation.workstation}
          </div>
          <div
            className={styles.manpower}
            title={`${$gt('Manpower Check-In:')} ${workstation.manpower_check_in}`}
          >
            {$gt('Manpower Check-In:')} {workstation.manpower_check_in}
          </div>
        </div>
        <div className={styles.throughput}>
          <div className={styles.throughputLabel}>
            <span>{$gt('Throughput')}</span>
            <span>/{$gt('Target')}</span>
          </div>
          <div className={styles.throughputValue}>
            <span style={{ color }}>{transformNum(totalThroughput)}</span>
            <span>/{transformNum(workstation.target)}</span>
          </div>
        </div>
        <Progress
          className={styles.progress}
          percent={totalThroughput / target * 100}
          strokeColor={color}
          showInfo={false}
        />
      </div>
    );
  };
  return (
    <div className={styles.workstationInfo}>
      <div className={styles.head}>
        <Form.Legend
          level={1}
          className={styles.legend}
        >
          {$gt('Workstation Info')}
        </Form.Legend>
        {props.totalPage > 0 && (
          <span className={styles.page}>
            {props.curPage + 1}/{props.totalPage} {$gt('Page')}
          </span>
        )}
      </div>
      <Spin
        className={styles.content}
        spinning={props.loading}
        size="large"
      >
        {props.curWorkstationList?.map((workstation, index) => {
          return renderWorkstationInfo(workstation, index);
        })}
        {!props.curWorkstationList.length && (
          <div className={styles.empty}>
            <Empty />
          </div>
        )}
      </Spin>
    </div>
  );
};

export default WorkstationInfo;
